import { render } from "./Pedido.vue?vue&type=template&id=2570523b&scoped=true"
const script = {}

import "./Pedido.vue?vue&type=style&index=0&id=2570523b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Usuario\\Desktop\\prueba\\Blooz\\blooz\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2570523b"]])

export default __exports__